import React from "react";
import AboutContent from "./content";
import AboutHeader from "./header";
import AboutSlider from "./slider";
import { useAboutUs } from "../../hooks/apis/main";

function About_components() {

    const { data: aboutData, isLoading, error } = useAboutUs();

    if (isLoading) return <div className="active loading">
        <img src="/images/loading.svg" className="img-fluid" />
    </div>;
    if (error) return <p>Error</p>;

    return (
        <div id="about">
            <AboutHeader />
            <AboutContent data={aboutData.data.page_detail} />
            <AboutSlider data={aboutData.data.gallery} />
        </div>
    );

}

export default About_components;